module.exports = __WEBPACK_EXTERNAL_MODULE_29__;


//////////////////
// WEBPACK FOOTER
// external {"root":"moment","commonjs2":"moment","commonjs":"moment","amd":"moment"}
// module id = 29
// module chunks = 0